module.exports = __webpack_public_path__ + "img/anna-korper.bf800828.jpg";